import type { ConsoleScreenMap } from '../types'
import { lazyScreen } from '../lazyScreen'
const ContactSalesScreen = lazyScreen(() => import('./ContactSalesScreen'), (m) => m.ContactSalesScreen)
/* MASTER-PLAN §3 F4 — stubs until PKG-ACCESS (reset) and PKG-SALES (quote) replace them. */
const ResetPasswordScreen = lazyScreen(() => import('./ResetPasswordScreen'), (m) => m.ResetPasswordScreen)
const QuoteAcceptScreen = lazyScreen(() => import('./QuoteAcceptScreen'), (m) => m.QuoteAcceptScreen)

/**
 * The public tier's redesigned screens, by route. A route listed here is served
 * by the console registry ahead of AppRouter's older switch; a route not
 * listed keeps its existing screen. Owned by the public workstream.
 *
 * ⚠️ THE SIGN-IN DOORS AND THE INVITE CLAIM ARE NOT HERE, ON PURPOSE. AppRouter
 * does token and door work for those routes (the invite token from the hash,
 * the wrong-door sign-out), so they are restyled in place in
 * `features/auth/screens/*` rather than re-registered.
 */
export const PUBLIC_SCREENS: ConsoleScreenMap = {
  'contact-sales': { component: ContactSalesScreen, frame: 'bare' },
  'reset-password': { component: ResetPasswordScreen, frame: 'bare' },
  'quote-accept': { component: QuoteAcceptScreen, frame: 'bare' },
}
